"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var NAME = 'header3';
var Header3 = /** @class */ (function (_super) {
    __extends(Header3, _super);
    function Header3() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'h3'; };
        _this.textMatcher = [
            {
                matcher: /^(#{3})\s$/,
                handler: function (match) {
                    return {
                        level: match[1].length
                    };
                }
            }
        ];
        _this.attrs = {
            level: {
                default: 3
            }
        };
        _this.parseDOM = [{ tag: 'h3', attrs: { level: 3 } }];
        return _this;
    }
    return Header3;
}(core_utilities_1.Block));
exports.Header3 = Header3;
var Header3Controller = /** @class */ (function (_super) {
    __extends(Header3Controller, _super);
    function Header3Controller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'header3',
            tooltip: 'header3'
        };
        return _this;
    }
    return Header3Controller;
}(core_utilities_1.SylController));
exports.Header3Controller = Header3Controller;
var Header3Plugin = /** @class */ (function (_super) {
    __extends(Header3Plugin, _super);
    function Header3Plugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = Header3Controller;
        _this.Schema = Header3;
        return _this;
    }
    return Header3Plugin;
}(core_utilities_1.SylPlugin));
exports.Header3Plugin = Header3Plugin;
//# sourceMappingURL=header3.js.map